import {ActionTree} from 'vuex';
import Vue from 'vue';
import axios from 'axios';
import {RootState} from '@/store/types';
import {TemplatesState, ViberTemplateItem} from './types';
import {directDownload} from "@/utils/download-helper";
import {TemplatesFilterParams} from "@/store/sms/templates/types";

export const actions: ActionTree<TemplatesState, RootState> = {
  getViberTemplates: ({commit, dispatch}, data: TemplatesFilterParams) => {
    return new Promise((resolve, reject) => {
      axios({
        url: '/viber/templates',
        params: data,
      })
        .then((resp:any) => {
          commit('setViberTemplates', resp.data.templates);
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
    })
  },
  exportViberTemplates: ({commit, dispatch}, data: TemplatesFilterParams) => {
    return directDownload('/viber/templates/export', data)
  },
  getViberMultichannelTemplates: ({commit, dispatch}, data: any) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `/${data.transport}/templates`,
        params: data.filter
      })
        .then((resp:any) => {
          commit('setViberMultichannelTemplates', resp.data.templates);
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
    })
  },
  getViberTemplateItem: ({commit, dispatch}, id) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `viber/templates/${id}`,
        params: {cache: Math.random()},
      })
        .then((resp:any) => {
          let smsItem = <ViberTemplateItem>resp.data;
          smsItem.ttl = smsItem.ttl ? smsItem.ttl / 3600 : null
          smsItem.id = id;
          commit('setViberTemplateItem', smsItem);
          resolve(smsItem)
        })
        .catch((err:any) => {
          reject(err)
        })
    })
  },
  saveViberTemplate: ({commit, dispatch}, data: ViberTemplateItem) => {
    return new Promise((resolve, reject) => {
      data.ttl = data.ttl ? data.ttl * 3600 : null
      data.send_evenly = data.send_evenly ?? 0
      data.save_text = data.save_text ?? 0
      axios({
        method: data.id ? 'put' : 'post',
        url: '/viber/templates/' +  (data.id ?? ''),
        data: data
      })
        .then((resp:any) => {
          console.log(resp.data);
          dispatch('getViberTemplates');
          resolve(resp)
        })
        .catch((err:any) => {
          // errorNotify(err);
          reject(err)
        })
    })
  },
  deleteViberTemplate: ({commit, dispatch}, data: ViberTemplateItem) => {
    return new Promise((resolve, reject) => {
      let editId = '';
      if (!data.id) {return}
      editId = data.id.toString();

      axios({
        method: 'delete',
        url: '/viber/templates/'+editId,
        data: data
      })
        .then((resp:any) => {
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
    })
  },
};